import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

/**
 * Groupe les éléments par leur parent commun pour l'effet domino
 */
function groupElementsByParent(selector) {
  const elements = Array.from(document.querySelectorAll(selector));
  const groups = new Map();

  elements.forEach((el) => {
    const parent = el.parentElement;
    if (!groups.has(parent)) {
      groups.set(parent, []);
    }
    groups.get(parent).push(el);
  });

  return groups;
}

function initFadeIn() {
  // Définir l'état initial pour tous les éléments fade-in
  document.querySelectorAll(".fade-in").forEach(el => {
    gsap.set(el, {
      opacity: 0
    });
  });

  // Immediate animation avec effet domino
  const immediateGroups = groupElementsByParent(".fade-in.immediate");

  immediateGroups.forEach((elements, parent) => {
    if (elements.length > 1) {
      // Effet domino pour plusieurs éléments
      gsap.to(
        elements,
        {
          opacity: 1,
          duration: 0.8,
          ease: "power2.out",
          stagger: 0.15, // Délai de 0.15s entre chaque élément
          delay: 0.1 // Petit délai pour éviter le flash
        }
      );
    } else {
      // Animation simple pour un seul élément
      gsap.to(
        elements[0],
        {
          opacity: 1,
          duration: 0.8,
          ease: "power2.out",
          delay: 0.1
        }
      );
    }
  });

  // On-scroll animation avec effet domino
  const scrollGroups = groupElementsByParent(".fade-in.on-scroll");

  scrollGroups.forEach((elements, parent) => {
    if (elements.length > 1) {
      // Effet domino pour plusieurs éléments
      gsap.to(
        elements,
        {
          opacity: 1,
          duration: 0.8,
          ease: "power2.out",
          stagger: 0.15,
          scrollTrigger: {
            trigger: parent, // Utiliser le parent comme trigger
            start: "top 80%",
            toggleActions: "play none none none",
          },
        }
      );
    } else {
      // Animation simple pour un seul élément
      gsap.to(
        elements[0],
        {
          opacity: 1,
          duration: 0.8,
          ease: "power2.out",
          scrollTrigger: {
            trigger: elements[0],
            start: "top 80%",
            toggleActions: "play none none none",
          },
        }
      );
    }
  });
}

// Exposer la fonction globalement pour Barba.js
window.initFadeIn = initFadeIn;

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initFadeIn);
} else {
  initFadeIn();
}

